import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const RequireRole = ({ allowedRoles }) => {
  const { userData, loading } = useSelector(
    (state) => state.workerInfo
  );

  if (loading) {
    return <p className="text-muted">Checking permissions...</p>;
  }

  if (!userData || !allowedRoles.includes(userData.role_id)) {
    return <Navigate to="/panel" replace />;
  }

  return <Outlet />;
};

export default RequireRole;
